import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  Thead,
  Flex,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Link,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  Stack,
  Select,
} from "@chakra-ui/react";
import YouTube from "react-youtube";
import { FaPlay, FaFileAlt } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Student_view = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [materials, setMaterials] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchField, setSearchField] = useState("file_name");

  const [videoId, setVideoId] = useState("");
  const [materialUrl, setMaterialUrl] = useState("");
  const [isYouTube, setIsYouTube] = useState(false);
  const [studentId, setStudentId] = useState(null);
  const [selectedSubject, setSelectedSubject] = useState(""); 
  const [subjects, setSubjects] = useState([]); 
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    const fetchMaterials = async () => {
      const token = sessionStorage.getItem("jwt");
      const storedStudentId = sessionStorage.getItem("user_id");
      if (storedStudentId) {
        setStudentId(storedStudentId);
      }

      try {
        const response = await fetch(
          `${BASE_URL}/staff/course_materials/list_materials_to_student.php`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ pass: storedStudentId }),
          }
        );

        const data = await response.json();
        console.log("Materials Response:", data);

        if (data.success) {
          setMaterials(data.materials || []);
          const uniqueSubjects = [
            ...new Set(data.materials.map((material) => material.subject)),
          ];
          setSubjects(uniqueSubjects);
        } else {
          console.error("Error from API:", data.message);
        }
      } catch (error) {
        console.error("Error fetching course materials:", error);
      }
    };

    fetchMaterials();
  }, [studentId]);

  const extractYouTubeID = (url) => {
    const standardMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^\s&]+)/ 
    );
    if (standardMatch) return standardMatch[1];

    const shortenedMatch = url.match(
      /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^\s&]+)/ 
    );
    if (shortenedMatch) return shortenedMatch[1];

    return null;
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = Number(e.target.value);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); 
  };

  const handleVideoClick = (url) => {
    const videoID = extractYouTubeID(url);
    if (videoID) {
      setVideoId(videoID);
      setMaterialUrl(url);
      setIsYouTube(true);
      setIsOpen(true);
    } else {
      setVideoId("");
      setMaterialUrl(url);
      setIsYouTube(false);
      setIsOpen(true);
    }
  };

  const closeModal = () => {
    setIsOpen(false);
    setVideoId("");
    setMaterialUrl("");
    setIsYouTube(false);
  };

  const opts = {
    height: "600",
    width: "100%",
  };

  const filteredMaterials = selectedSubject
    ? materials.filter((material) => material.subject === selectedSubject)
    : materials;

  const totalPages = Math.ceil(filteredMaterials.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = filteredMaterials.slice(startIndex, startIndex + rowsPerPage);

  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
      } else if (currentPage >= totalPages - 2) {
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        for (let i = currentPage - 2; i <= currentPage + 2; i++) {
          pages.push(i);
        }
      }
    }
    return pages;
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Box>
      <div style={{ backgroundColor: "#FBFBFD", height: "100vh" }}>
        <div className="teacher-list-container">
          <div className="header">
            <h1 style={{ fontSize: "20px", margin: 0 }}>Course Material</h1>
          </div>
          <div className="breadcrumb">
            <span>Staff</span> / <span>Course Material</span> /{" "}
            <span>View</span>
          </div>
        </div>
        <Box p={6}>
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align="center"
            p={3}
            className="sb"
          >
            <Box mb={{ base: 4, md: 0 }}>
              <Flex align="center">
                <Text mr={2}>Rows Per Page</Text>
                <Select
                  width="100px"
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                  borderColor="#E9EDF4"
                >
                  <option value={5}>5</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </Select>
              </Flex>
            </Box>

            <Box width={{ base: "100%", md: "auto" }}>
              <Select
                placeholder="Select Subject"
                value={selectedSubject}
                onChange={(e) => setSelectedSubject(e.target.value)}
                mb={4}
              >
                {subjects.map((subject, index) => (
                  <option key={index} value={subject}>
                    {subject}
                  </option>
                ))}
              </Select>
            </Box>
          </Flex>

          <Box>
            <Box overflowX="auto" maxWidth="100%">
              <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
                <Thead>
                  <Tr>
                    <Th>File Name</Th>
                    <Th>Class</Th>
                    <Th>Subject</Th>
                    <Th>Caption</Th>
                    <Th>Staff</Th>
                    <Th>Material File</Th>
                    <Th>Material Link</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {currentData.length > 0 ? (
                    currentData.map((material) => (
                      <Tr key={material.id}>
                        <Td>{material.file_name}</Td>
                        <Td>{material.class || "N/A"}</Td>
                        <Td>{material.subject || "N/A"}</Td>
                        <Td>{material.caption || "N/A"}</Td>
                        <Td>{material.name || "N/A"}</Td>
                        <Td>
                          {material.file_url ? (
                            <Link
                              href={material.file_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              display="flex"
                              alignItems="center"
                            >
                              <FaFileAlt style={{ marginRight: "8px" }} /> View
                              File
                            </Link>
                          ) : (
                            "No File"
                          )}
                        </Td>
                        <Td>
                          {material.material_link ? (
                            <IconButton
                              icon={<FaPlay />}
                              aria-label="Play Material"
                              onClick={() =>
                                handleVideoClick(material.material_link)
                              }
                              colorScheme="blue"
                            />
                          ) : (
                            "No Link"
                          )}
                        </Td>
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan="7">
                        <Text textAlign="center">No materials available</Text>
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
           
            </Box>
            <Flex justify="end" borderTopWidth="1px" p={3} className="sb2">
                <Button
                  onClick={() => handlePageChange(currentPage - 1)}
                  isDisabled={currentPage === 1}
                >
                  Prev
                </Button>
                <Stack direction="row" mx={2}>
                  {getPageNumbers().map((pageNum) => (
                    <Button
                      key={pageNum}
                      onClick={() => handlePageChange(pageNum)}
                      backgroundColor={
                        currentPage === pageNum ? "teal" : "gray.100"
                      }
                      color={currentPage === pageNum ? "white" : "black"}
                    >
                      {pageNum}
                    </Button>
                  ))}
                </Stack>
                <Button
                  onClick={() => handlePageChange(currentPage + 1)}
                  isDisabled={currentPage === totalPages}
                >
                  Next
                </Button>
              </Flex>
          </Box>
        </Box>
      </div>

      {/* Modal for video */}
      <Modal isOpen={isOpen} onClose={closeModal} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Material</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {isYouTube ? (
              <YouTube videoId={videoId} opts={opts} />
            ) : (
              <Text>
                The content cannot be displayed in an iframe.{" "}
                <a
                  href={materialUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "blue" }}
                >
                  Click here to view it directly
                </a>
              </Text>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Student_view;
